<template>
  <div class="to-start">
    <div class="content margin-general">
      <div class="content-text">
        <div class="title-descript">
          <h2>{{ $t("accounts.toStart.title") }}</h2>
          <p class="body-4">{{ $t("accounts.toStart.desc") }}</p>
        </div>
        <div class="card">
          <ul>
            <li class="body-4" v-for="(item, index) in itemsList" :key="index">
              {{ $t(item.value) }}
            </li>
          </ul>
        </div>
      </div>
      <div class="content-img">
        <h2>{{ $t("accounts.toStart.title") }}</h2>
        <p class="body-4">{{ $t("accounts.toStart.desc") }}</p>
        <NuxtImg
            :src="imageSrc"
            alt="Head of marketing, bitcoin and forex"
            width="509"
            height="506" 
            format="webp"
            quality="85"
            loading="lazy"
            decoding="async"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useNuxtApp } from '#app';
// 

const { $regulationsVar } = useNuxtApp();
const { locale } = useI18n();

const itemsList = ref([
  { value: "accounts.toStart.item1" },
  { value: "accounts.toStart.item2" },
  { value: "accounts.toStart.item3" },
  { value: "accounts.toStart.item4" },
  { value: "accounts.toStart.item5" },
  { value: "accounts.toStart.item6" },
]);

const config = {
  'default': {
    image: '/images/accounts/Accounts-Img2.png',
  }
};

const currentRegulation = computed(() => $regulationsVar.getRegulation(locale.value));

const imageSrc = computed(() => {
  return config[locale.value]?.image || config[currentRegulation.value]?.image || config['default'].image;
});
</script>